import {
  Box,
  Button,
  FormControl,
  InputAdornment,
  ListItemIcon,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { onGetDonations, onGetDonationTypes } from "../../src/utils/queries";

const ParticipantFilter = ({ setFilter, value, setValue, setNames }) => {
  // const [value, setValue] = useState([]);
  const [textBox, setTextBox] = useState("");
  const [open, setOpen] = React.useState(false);

  const [list, setList] = useState([]);
  const [filteredList, setFilteredList] = useState([...list]);
  const filterRef = React.useRef();

  // useEffect(() => {
  //   //get all unique donation types
  //   const unique = [
  //     ...new Set(
  //       [].map(
  //         (item) => item.values["donation_details[0].donation_type.type"]
  //       )
  //     ),
  //   ];
  //   setList(unique);
  // }, [value]);

  const handleChange = (event) => {
    // console.log(event.target.value.join(", "));
    // console.log(event.target.value)
    setTextBox(event.target.value)
    setValue((prev) => ({
      ...prev,
      donor_type: event.target.value,
    }));
    setFilter((prev) => ({
      ...prev,
      donor_type: event.target.value,
      page: 1,
    }));
  };


  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };
  return (
    <FormControl>
      <Select
        autoWidth
        displayEmpty
        size="small"
        value={value?.donor_type || ''}
        open={open}
        onClose={handleClose}
        onOpen={handleOpen}
        renderValue={(selected) => {
          if (!selected) {
            return <Typography variant="big">Donor Type</Typography>;
          }

          return selected;
        }}
        sx={{
          borderRadius: "16px",
          "&.Mui-focused": {
            // color:"primary.main",
            // border:"1px solid black",
            "& .MuiOutlinedInput-notchedOutline": {
              boxShadow: "none",
              //used to remove blue styling
              border: "1px solid",
              borderColor: "grey.main",
            },
          },
        }}
        onChange={(event) => handleChange(event)}
        //  open={open}
        id="demo-simple-select"
        //   onChange={handleChange}
      >
        {/* <MenuItem onKeyDown={moveFocusToInput} component={'span'}> */}
        {/* </MenuItem> */}
        <MenuItem value={"participant"}>Participant</MenuItem>
        <MenuItem value={"donor"}>Donor</MenuItem>
        <Box p={2}>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            onClick={handleClose}
          >
            Close
          </Button>
        </Box>
      </Select>
    </FormControl>
  );
};

export default ParticipantFilter;
